import { useAuthContext } from "../contexts/auth-context";
import {
    apiRequestGet,
    apiRequestPost,
    apiRequestSecuredPost,
} from "../lib/common/api";
import { TGenericApiResponse } from "../lib/types/general";
import { TCitiesData, TMapCoordinateData } from "../lib/types/labs";
import { TRegion } from "../lib/types/regions";

let regionsCache: TRegion[] = [];

export const getRegions = async (): Promise<TRegion[]> => {
    if (regionsCache.length) return regionsCache;

    const regions = await apiRequestGet<{ results: TRegion[] }>("georegions");

    regionsCache = regions.data.results;

    return regions.data.results;
};

let regionsWithHiringLabsCache: TRegion[] = [];
export const getRegionsWhereLabsAreHiring = async (): Promise<
    TGenericApiResponse<TRegion[]>
> => {
    if (regionsWithHiringLabsCache.length)
        return {
            data: regionsWithHiringLabsCache,
        };

    const regions = await apiRequestGet<TGenericApiResponse<TRegion[]>>(
        "georegions/hiringlabs"
    );

    regionsWithHiringLabsCache = regions.data.data;

    return regions.data;
};

export const useAddress = () => {
    const { getUserTokenId } = useAuthContext();
    const getCities = async (
        name: string
    ): Promise<TGenericApiResponse<TCitiesData[]>> => {
        const cities = await apiRequestPost<TGenericApiResponse<TCitiesData[]>>(
            "georegions/cities",
            {
                name,
            }
        );

        return cities.data;
    };

    const getCoordinates = async (user_id: number) => {
        const coordinates = await apiRequestSecuredPost<
            TGenericApiResponse<TMapCoordinateData[]>
        >("georegions/map-locations", await getUserTokenId(), {
            user_id,
        });
        return coordinates.data;
    };

    const updateCoordinates = async (
        lat: number,
        long: number,
        user_id: number
    ) => {
        const userTokenId = await getUserTokenId();

        return apiRequestSecuredPost(
            "georegions/update-map-location",
            userTokenId,
            {
                lat: lat,
                long: long,
                user_id,
            }
        );
    };

    return {
        getCities,
        getCoordinates,
        updateCoordinates,
    };
};
